// 通用微信分享

// 引入微信sdk axios
import wx from "weixin-js-sdk";
import requestGlobal from "@/api";
import { Toast } from "vant";
import { baseUrl } from "@/utils/common";

var wechatlinklurl = window.location.href.split("#")[0];

/**
 * @param title - 分享的标题
 * @param desc - 具体描述
 * @param img - 分享的图片
 * @param url - 分享链接
 * @description 通用微信分享方法
 * @public
 **/
export function wxsharepublic(title, desc, img, url) {
  if (!title) {
    Toast("请传入分享的标题");
    return;
  }
  if (!desc) {
    Toast("请传入分享的详细描述");
    return;
  }
  if (!url) {
    Toast("请传入分享的链接");
    return;
  }
  if (!img) {
    img = baseUrl + "/projectimg/newlogo.png";
  }
  // 微信配置
  requestGlobal.wxGetSign({
    url: wechatlinklurl
  }).then(res => {
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: res.data.appId,
      timestamp: res.data.timestamp, // 必填，生成签名的时间戳
      nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
      signature: res.data.signature,
      jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline", "chooseWXPay"],
      openTagList: ["wx-open-launch-weapp"] // 可选，需要使用的开放标签列表
    });
    wx.ready(function() {
      wx.onMenuShareAppMessage({
        title: title, // 分享标题
        desc: desc, // 分享描述
        link: url, // 分享链接
        imgUrl: img // 分享图标
      });
      wx.onMenuShareTimeline({
        title: title, // 分享标题
        desc: desc, // 分享描述
        link: url, // 分享链接
        imgUrl: img // 分享图标
      });
    });
    wx.error(function(res) {
      // config信息验证失败会执行 error 函数，如签名过期导致验证失败，具体错误信息可以打开 config 的debug模式查看，也可以在返回的 res 参数中查看，对于 SPA 可以在这里更新签名。
      Toast(res);
      console.log(res);
    });
  }).catch(err => {
    Toast(err);
  });
}




// WEBPACK FOOTER //
// ./src/utils/wxShare.js